import { Component, Input, OnInit } from '@angular/core';
import { VhQueryAutoWeb } from 'vhautowebdb';

@Component({
  selector: 'atw-select-admin',
  templateUrl: './select-admin.component.html',
  styleUrls: ['./select-admin.component.scss']
})
export class AtwSelectAdmin implements OnInit {
  @Input() data: any;
  @Input() type: any;
  @Input() staticdata: any; // là dữ liệu staticdata từ database

  constructor(
    private vhQueryAutoWeb: VhQueryAutoWeb
  ) { }

  ngOnInit() {
  }

  addData() {
    this.staticdata.data_list = [...this.staticdata.data_list, {
      _id: new Date().getTime(),
      label: '',
      value: '',
    }]

    this.updateStaticData()
  }

  deleteRow(_id: any) {
    this.staticdata.data_list = this.staticdata.data_list.filter((item: any) => item._id !== _id);
    this.updateStaticData()
  }

  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.data._id, {
      staticdata: this.staticdata
    })
  }
}
